import { render, staticRenderFns } from "./signup-page.vue?vue&type=template&id=483147fc&scoped=true&lang=pug&"
import script from "./signup-page.vue?vue&type=script&lang=ts&"
export * from "./signup-page.vue?vue&type=script&lang=ts&"
import style0 from "./signup-page.vue?vue&type=style&index=0&id=483147fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483147fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
